import type { TimerObjectV2 } from "@bezpart-board/shared";
import { nextZIndex } from "../../editor/zIndex";

const DEFAULT_DURATION_MS = 5 * 60 * 1000;
export const TIMER_DEFAULT_SIZE = { w: 300, h: 248 } as const;

/** Создаёт объект таймера, центрированный в (cx, cy). */
export function createTimerObject(
  cx: number,
  cy: number,
  existingObjects: { zIndex?: string }[] = []
): TimerObjectV2 {
  const { w, h } = TIMER_DEFAULT_SIZE;
  return {
    id: crypto.randomUUID(),
    type: "timer",
    x: Math.round(cx - w / 2),
    y: Math.round(cy - h / 2),
    w,
    h,
    durationMs: DEFAULT_DURATION_MS,
    remainingMs: DEFAULT_DURATION_MS,
    status: "idle",
    zIndex: nextZIndex(existingObjects),
  };
}
